import spinnerStyles from "../../styles/docs/docsSpinner.module.scss";

const DocsContentSpinner = () => (
  <div className={spinnerStyles.wrapper} aria-busy="true" role="status">
    <div className={spinnerStyles.spinner} aria-hidden="true" />
  </div>
);

export default DocsContentSpinner;
